import $ from 'jquery'
import * as moment from 'moment'
import OpenDateService from './../services/OpenDateService'
import GetActivityPriceService from './../services/GetActivityPriceService'
import config from '@root/js/api.config'


/*
 * PANEL SELECTOR JQuery
 */
const PANEL_SELECTOR = $('.reservation-panel')

/*
 * CSS CLASS FOR DATEPICKER
 * Define in activity/static/activity/sass/activity.scss
 */
const ACTIVE = 'active'
const VALID_DATE_CLASS = 'open-date'
const INVALID_DATE_CLASS = 'invalid-date'
const VALID_OPEN_DATE_ON_RETURN_CLASS = 'open-date-on-return'
const SELECT_START_DATE_CLASS = 'select-start-date'
const SELECT_BETWEEN_START_END_DATE_CLASS = 'between-start-end-date'
const SELECT_END_DATE_CLASS = 'select-end-date'
const NOTOPEN_DATE_CLASS = 'notopen-date'
const EVENT_DATE_CLASS_OPEN = 'event-open'
const EVENT_DATE_CLASS_CLOSE = 'event-close'

export default class ReservationPanel {

  constructor (i18n_data) {
    // Attributes
    this.id = undefined
    this.opendates = undefined
    this.opendates = undefined
    this.openDateService = undefined
    this.$start = undefined
    this.$end = undefined
    this.active_type = undefined
    this.active_mode = undefined
    this.session_data = undefined

    // Init
    this.initSelectors()
    this.refreshActiveType()
    this.refreshPriceHeading()
    this.initEventListener()

    // Fletch API Service Open Date
    this.GetActivityPriceService = new GetActivityPriceService(config, 'activityprice')

    // Fletch API Service Open Date
    this.openDateService = new OpenDateService(config, 'opendate')
    this.openDateService.get(this.id).then((data) => {
      this.opendates = data.dates
      this.searchedDate = data.searched
      if(
        this.opendates &&
        Object.keys(this.opendates).length != 0) {
        this.initDatePickers()
        this.initFromSessionStorage()
        this.$spinner.hide()
      } else {
        // this.$selector.remove()
        this.$spinner.hide()
      }
    })

    this._translation = {}
    for (var key in i18n_data) {
        this._translation[key] = i18n_data[key];
    }
  }

  static seti18nParam(data) {

  };

  /*
   * Static Method
   * -------------------------------------------------------------------------------------------------------------------
   */

  static getClassName () { return 'ReservationPanel' }
  getClassName () { return ReservationPanel.getClassName() }

  /*
   * Utils Methods
   * -------------------------------------------------------------------------------------------------------------------
   */

   get_session_storage_key() {
    return 'book-form-' + this.id
   }

  /*
   * Init Methods
   * -------------------------------------------------------------------------------------------------------------------
   */

  initSelectors () {
    this.$selector = PANEL_SELECTOR
    this.$content = this.$selector.find('.reservation-panel-content')
    this.$price_heading = this.$selector.find('.price-heading')
    this.$close = this.$selector.find('.close')
    this.$spinner = this.$selector.find('.background-search-loader')
    this.$tabs = this.$selector.find('.booking-gift-tabs a[data-toggle="tab"]')
    if(this.$tabs.length == 0) {
      this.active_mode = 'booking'
    } else {
      this.active_mode = this.$tabs.filter('.active').attr('id').split('-')[0]
    }
    this.$activity = this.$selector.find('input[name="activity"]')
    this.$booking_form = this.$selector.find('#booking-form')
    this.$gift_form = this.$selector.find('#gift-form')
    this.$reservation_type_radio_select = this.$selector.find('input[name="reservation_type"]')
    this.$booking_reservation_type_radio_select = this.$booking_form.find('input[name="reservation_type"]')
    this.$gift_reservation_type_radio_select = this.$gift_form.find('input[name="reservation_type"]')
    this.active_type = this.$reservation_type_radio_select.val()
    this.$start = this.$selector.find('input[name="start"]')
    this.$end = this.$selector.find('input[name="end"]')
    this.$date_wng = this.$selector.find('#date-wng')
    this.$all_passenger_number = this.$selector.find('input[name="passenger_number"]')
    this.$adult_child_number = this.$selector.find('input[name="adult_number"],input[name="child_number"]')
    this.$booking_passenger_number = this.$booking_form.find('input[name="passenger_number"]')
    this.$booking_adult_child_table = this.$booking_form.find('.adult-child')
    this.$booking_adult_number = this.$booking_form.find('input[name="adult_number"]')
    this.$booking_child_number = this.$booking_form.find('input[name="child_number"]')
    this.$gift_passenger_number = this.$gift_form.find('input[name="passenger_number"]')
    this.$gift_adult_child_table = this.$gift_form.find('.adult-child')
    this.$gift_adult_number = this.$gift_form.find('input[name="adult_number"]')
    this.$gift_child_number = this.$gift_form.find('input[name="child_number"]')
    this.$adult_child_appply = this.$selector.find('.adult-child-apply')
    this.$schedule_select = this.$selector.find('select[name="schedule"]')
    this.id = this.$selector.data('id')
    this.$forms = this.$selector.find('#booking-form,#gift-form')
    this.$price_detail_table = this.$selector.find('.price-detail-table')
      this.$price_detail_targets = {
      price_per: this.$selector.find('.price-detail-price_per'),
      unit_price: this.$selector.find('.price-detail-unit_price'),
      duration: this.$selector.find('.price-detail-duration'),
      travelers_nb: this.$selector.find('.price-detail-travelers_nb'),
      total_price: this.$selector.find('.price-detail-total_price'),
      warning_msg: this.$selector.find('.price-detail-warning_msg'),
      promo: this.$selector.find('.price-detail-promo')
    }
    this.$cta_buttons = $('.call-to-actions button[type="submit"]')
    this.$mobile_buttons = $('.mobile-buttons-container button')
    this.$authentication_modal = $('#authentication-modal')
    this.$selector[0]['manager'] = this
  }

  initEventListener () {
    this.$tabs.on('shown.bs.tab', (e) => this.onBookingTabShow(e))
    this.$reservation_type_radio_select.on('change', (e) => this.onReservationTypeChange(e))
    this.$end.on('click', () => {
      if (this.$start.datepicker('getDate') === null) {
        this.$end.datepicker('hide')
        this.$start.datepicker('show')
      }
    })
    this.$all_passenger_number.on('change', () => {
      this.onNbPersonsChange()
    })
    this.$adult_child_number.on('change', (e) => {
      this.onAdultChildChange(e)
    }) //.change()
    $('.plus .btn-rounded').on('click', (e) => {
      this.onAdultChildPlusClick(e)
    })
    $('.minus .btn-rounded').on('click', (e) => {
      this.onAdultChildMinusClick(e)
    })
    this.$adult_child_appply.on('click', (e) => {
      this.onAdultChildApply(e)
    })

    this.$cta_buttons.on('click', (e) => {
        $('#submit_action').val($(e.target).attr('name'))
    })
    this.$forms.on('submit', (e) => {
      if($('#submit_action').val() == 'action-quote') {
        let url = this.$booking_form.data('url_rental_quote') + '?'
        let nb_passengers = this.$all_passenger_number.val()
        if(nb_passengers){
          url += '&nb_passengers=' + nb_passengers
        }
        let start = this.$start.val()
        if(start){
          url += '&start=' + start
        }
        let end = this.$end.val()
        if(end){
          url += '&end=' + end
        }
        window.location.href = url
        return false
      }
      // Check date fields
      let is_valid = true
      if (this.active_mode == 'booking') {
        if (this.$start.datepicker('getDate') === null) {
          $(this.$start).parent().addClass('invalid')
          $(this.$date_wng).show()
          is_valid = false
        }
        if (this.$end.datepicker('getDate') === null) {
          $(this.$end).parent().addClass('invalid')
          $(this.$date_wng).show()
          is_valid = false
        }
        if (this.$schedule_select.val() === null) {
          $(this.$schedule_select).parent().addClass('invalid')
          is_valid = false
        }
      }
      if (is_valid == false) {
        return false
      }
      if(!$('body').data('userloggedin')) {
        // Save form date to refill form after page reload
        sessionStorage.setItem(this.get_session_storage_key(), $(e.target).serialize())
        // Open authentication modal
        window.authenticationFormsLoader.load('coord')
        return false;
      }
      return true;
    })

    this.$close.on('click', (e) => {
      // Hide panel
      this.$selector.attr( "style", "display: none !important;" )
      // Show mobile buttons
      this.$mobile_buttons.attr( "style", "display: block !important;" )
      // Show main nav bar
      $('.main-navbar').show()
      // Close datepickers
      this.$start.datepicker('hide')
      this.$end.datepicker('hide')
    })

    this.$mobile_buttons.on('click', (e) => {
      // Toggle call-to-actions
      let cta_target = $(e.target).data('cta-target')
      let cta = this.$booking_form.find('[name="'+ cta_target +'"]')
      cta.show()
      cta.siblings().hide()
      // Hide mobile buttons
      this.$mobile_buttons.attr( "style", "display: none !important;" )
      // Resize and show panel
      //let h = $($(this.element).data('parent-width-ref')).width()
      let h = document.documentElement.clientHeight - $('.main-navbar').height();
      this.$content.addClass('mobile')
      // this.$selector.attr( "style", "height:"+h+"px;display: block !important;" )
      this.$selector.attr("style", "position: fixed; display: block !important; top: 0;bottom: 0;left: 0;right: 0;z-index: 2000;")
      $('.main-navbar').hide()
      $('html').animate({scrollTop:$('.reservation-panel').offset().top-40}, 250);

      // Auto Open datepicker selector on mobile
      if (this.active_mode === 'booking') {
        if (this.$start.datepicker('getDate') === null) {
          this.$start.datepicker('show')
        } else {
          if (this.$end.datepicker('getDate') === null) {
            this.$end.datepicker('show')
          }
        }
      }

      // Dectection de retour en Mobile
      // 1. On modifie l'historique pour pouvoir intercepter le back
    history.pushState({ forced: true }, '', document.URL);

    // 2. On définit une fonction "handler" pour réagir au bouton Précédent
    const onPopState = (event) => {
      // - On cache l’élément
      this.$close.click();

      // - On supprime l’écouteur `popstate` pour rétablir le fonctionnement normal
      window.removeEventListener('popstate', onPopState);

      // - (Optionnel) On peut remettre l’URL dans le même état sans l’entrée forcée :
      history.replaceState(null, '', document.URL);
    }

    // 3. On écoute l'événement "popstate"
    window.addEventListener('popstate', onPopState);
    })
  }

  initFromSessionStorage () {
    let in_session = sessionStorage.getItem(this.get_session_storage_key())
    let data = {}
    let item
    if(in_session != undefined){

      // Unserialize data
      in_session = in_session.split('&');
      for (let i=0; i<in_session.length; i++) {
        item = in_session[i].split('=')
        data[decodeURIComponent(item[0])] = decodeURIComponent(item[1])
      }
      this.session_data = data

      // Set mode
      if(data['reservation_mode']=='gift') {
        this.active_mode = 'gift'
        $(this.$tabs[1]).tab('show')
      } else {
        this.active_mode = 'booking'
      }

      // Set type
      this.$reservation_type_radio_select.off('change')
      this.$reservation_type_radio_select.filter('[value="'+data['reservation_type']+'"]').click()
      this.$reservation_type_radio_select.on('change', (e) => this.onReservationTypeChange(e))
      this.refreshActiveType()

      // Set passengers
      this.getActivePassengerNumber().val(data['passenger_number'])
      this.getActiveAdultNumber().val(data['adult_number']).change()
      this.getActiveChildNumber().val(data['child_number']).change()

      // Set dates
      if(data['start']){
        this.$start.off('changeDate')
        this.$start.datepicker("setDate", data['start'])
        this.$start.on('changeDate',(e) => { this.onChangeStartDate(e)})
      }
      if(data['end']){
        this.$end.off('changeDate')
        this.$end.datepicker("setDate", data['end'])
        this.$end.on('changeDate',(e) => { this.onChangeEndDate(e)})
      }

      // Set schedule
      if(data['schedule']){
        let hour = '<option value="' + data['schedule'] + '">' + data['schedule'] + '</option>'
        this.$schedule_select.html(hour)
        this.$schedule_select.hide()
      }

      // Set action
      if(data['submit_action']){
        $('#submit_action').val(data['submit_action'])
      }

      // Refresh display
      this.refreshPriceHeading()
      this.refreshPriceTable()

      // Reset session data
      sessionStorage.removeItem(this.get_session_storage_key())

      // Submit form
      this.getForm().submit()

    }
  }

  initDatePickers () {
    this.initDatePickerStart()
    this.initDatePickerEnd()
    this.clear_dates()
  }

  initDatePickerStart () {
    // Init Start DatePicker
    window.DATEPICKER_OPTIONS['beforeShowDay'] = (date) => {
      return this.datePickerbeforeShowDayStart(date)
    }
    this.first_date = this.getFirstOpenDate()
    window.DATEPICKER_OPTIONS['defaultViewDate'] = {
      year: this.first_date.year(),
      month: this.first_date.month(),
      day: this.first_date.day()
    }
    this.$start.datepicker(window.DATEPICKER_OPTIONS)
      .on('changeDate', (e) => {
        this.onChangeStartDate(e)
      })
      .on('clearDate', () => {
        this.onClearDate()
      }).on('show', () => {
        this.onShowStart()
      })
  }

  initDatePickerEnd () {
    // Init End DatePicker
    window.DATEPICKER_OPTIONS['beforeShowDay'] = (date) => {
      return this.datePickerbeforeShowDayEnd(date)
    }

    this.$end.datepicker(window.DATEPICKER_OPTIONS)
      .on('clearDate', () => {
        this.onClearDate()
      })
      .on('changeDate', (e) => {
        this.onChangeEndDate(e)
      })
      .on('show', (e) => {
        this.onShowEnd()
        // When open "end" calendar, set classes on days based on active
        // selected day
        this.onReturnDateHover($('.datepicker').find('.end.active'))
      })

    $('body').on(
      'mouseenter',
      '.end.open-date, .end.between-start-end-date:not(.disabled), .end.select-end-date',
      (e) => {
        this.onReturnDateHover($(e.target))
      })
    $('body').on(
      'mouseenter',
      '.disabled',
      (e) => {
        this.onReturnDateOut()
      })
    $('body').on(
      'mouseleave',
      '.table-condensed',
      (e) => {
        this.onReturnDateOut()
      })
    }

  /*
   * Reservation type Handler
   * -------------------------------------------------------------------------------------------------------------------
  */

  onReservationTypeChange(e) {
      this.refreshActiveType()
      this.$start.off()  // unbind events
      this.$start.datepicker('destroy')
      this.initDatePickerStart()
      this.clear_dates(true)
      if(this.active_mode == 'gift') {
        this.refreshPriceTable()
      }
    }

  refreshActiveType() {
    if(this.active_mode == 'gift'){
      this.active_type = this.$gift_reservation_type_radio_select.filter(':checked,[type=hidden]').val()
    } else {
      this.active_type = this.$booking_reservation_type_radio_select.filter(':checked,[type=hidden]').val()
    }
    this.reinitAdultChildTable()
    this.refreshPriceHeading()
  }

  /*
   * Tab Event Handler
   * -------------------------------------------------------------------------------------------------------------------
   */
  onBookingTabShow (e) {
    let new_active_mode = this.$tabs.filter('.active').attr('id').split('-')[0];
    if (new_active_mode != this.active_mode) {
      this.active_mode = new_active_mode
      this.$selector.toggleClass('color-booking')
      this.$selector.toggleClass('color-gift')
      this.refreshActiveType()
      this.refreshPriceTable()
    }
  }

  /*
   * Handler Select Travelers
   * -------------------------------------------------------------------------------------------------------------------
   */
  getActivePassengerNumber() {
    if(this.active_mode == 'gift') {
      return this.$gift_passenger_number
    }
    return this.$booking_passenger_number
  }
  getActiveAdultChildTable() {
    if(this.active_mode == 'gift') {
      return this.$gift_adult_child_table
    }
    return this.$booking_adult_child_table
  }
  getActiveAdultNumber() {
    if(this.active_mode == 'gift') {
      return this.$gift_adult_number
    }
    return this.$booking_adult_number
  }
  getActiveChildNumber() {
    if(this.active_mode == 'gift') {
      return this.$gift_child_number
    }
    return this.$booking_child_number
  }

  refreshNbPersons() {
    let passenger_number = this.getActivePassengerNumber()
    passenger_number.val(this.getTotalAdultChild()).change()
  }

  onNbPersonsChange () {
    this.clear_dates(true)
    if(this.active_mode == 'gift') {
      this.refreshPriceTable()
    }
  }

  get_nb_persons_bounds() {
    let min = 0
    let max = 0
    let passenger_number = this.getActivePassengerNumber()
    if(this.active_type == 'private') {
      min = passenger_number.data('min-private')
      max = passenger_number.data('max-private')
    } else {
      min = passenger_number.data('min-shared')
      max = passenger_number.data('max-shared')
    }
    return [min, max]
  }

  getTotalAdultChild() {
    return parseInt(this.getActiveAdultNumber().val()) + parseInt(this.getActiveChildNumber().val())
  }

  reinitAdultChildTable() {
    this.getActiveAdultNumber().val(2).change()
    this.getActiveChildNumber().val(0).change()
    this.refreshNbPersons()
  }

  onAdultChildChange(e) {
    $(e.target).prev('.nb-txt').text($(e.target).val())
  }

  onAdultChildApply(e) {
    this.refreshNbPersons()
  }

  onAdultChildMinusClick(e) {
    let input = $($(e.target).closest('span').data('target'))
    let val = parseInt(input.val())
    let total = this.getTotalAdultChild()
    let min = this.get_nb_persons_bounds()[0]
    if(total != min && val != 0) {
      input.val(val - 1).change()
    }
  }

  onAdultChildPlusClick(e) {
    let input = $($(e.target).closest('span').data('target'))
    let val = parseInt(input.val())
    let total = this.getTotalAdultChild()
    let max = this.get_nb_persons_bounds()[1]
    if(total != max) {
      input.val(val + 1).change()
    }
  }

  /*
   * DatePicker CallBack beforeShowDay
   * -------------------------------------------------------------------------------------------------------------------
   * See : http://bootstrap-datepicker.readthedocs.io/en/latest/options.html?highlight=beforeShowDay
   */
  dateHasSlotOpenInFlexForType(date) {
    for (let time in this.opendates[date]) {
      if(this.opendates[date][time].flex_on.includes(this.active_type)) {
        return true
      }
    }
    return false
  }

  dateHasSlotOpenForType (date) {
    for (let time in this.opendates[date]) {
      if(this.opendates[date][time].on.includes(this.active_type)) {
        return true
      }
    }
    return false
  }

  dateIsValid(date) {
    return this.checkDateStatus(date)['classes'] == VALID_DATE_CLASS;
  }


  checkSlotStatus(s) {
    let passenger_number = this.getActivePassengerNumber()
    let nb_pers = parseInt(passenger_number.val())
    if(!s.checked) {
      return {enabled: false, classes: INVALID_DATE_CLASS,
              tooltip: this._translation['not-opened-date']}
    }
    if (this.active_type !== 'private') {
      if(s.remaining_places.shared > 0) {
        if(nb_pers >= s.missing_places.shared && nb_pers <= s.remaining_places.shared) {
            return {enabled: true, classes: VALID_DATE_CLASS,
                    tooltip: 'Départ ouvert'}
        } else if(nb_pers < s.missing_places.shared) {
            return {enabled: true, classes: VALID_DATE_CLASS,
                    tooltip: `Départ garanti à partir de ${s.missing_places.shared} personne(s) minimum`}
        } else {
          return {enabled: false, classes: INVALID_DATE_CLASS,
                  tooltip: `Départ garanti : seulement ${s.remaining_places.shared} place(s) restante(s)`}
        }
      } else {
        return {enabled: false, classes: NOTOPEN_DATE_CLASS,
                tooltip: 'Départ complet'}
      }
    } else {
      if(s.remaining_places.private > 0) {
        if(nb_pers >= s.missing_places.private) {
          return {enabled: true, classes: VALID_DATE_CLASS,
                  tooltip: 'Départ privé ouvert'}
        } else {
          return {enabled: true, classes: VALID_DATE_CLASS,
                  tooltip: `Départ privé ouvert : ${s.remaining_places.private} personnes minimum`}
        }
      } else {
        return  {enabled: false, classes: NOTOPEN_DATE_CLASS,
                tooltip: 'Départ privé indisponible'}
      }
    }
  }

  checkDateStatus (date) {
    var d = this.opendates[date]
    var r = {}
    var times_enabled = []
    var times_classes = []
    var times_tooltip = []
    var date_enabled = undefined
    var date_classes = undefined
    var date_tooltip = undefined

    for (let slot of this.opendates[date]) {
      r = this.checkSlotStatus(slot)
      times_enabled.push(r['enabled'])
      times_classes.push(r['classes'])
      times_tooltip.push(slot['start'] + ' : ' + r['tooltip'])
    }

    date_enabled = times_enabled.includes(true)
    if(times_classes.includes(VALID_DATE_CLASS)){
      date_classes = VALID_DATE_CLASS
    } else if (times_classes.includes(INVALID_DATE_CLASS)) {
      date_classes = INVALID_DATE_CLASS
    } else {
      date_classes = NOTOPEN_DATE_CLASS
    }
    date_tooltip = times_tooltip.join('\n')
    return  {enabled: date_enabled, classes: date_classes,
             tooltip: date_tooltip}

  }

  datePickerbeforeShowDayStart (date) {
    date = moment(date).format('DD/MM/YYYY')
    for (let key in this.opendates) {
      if (key === date) {
        if (this.dateHasSlotOpenForType(date)) {
          return this.checkDateStatus(date)
        }
      }
    }
    // Date not Open
    return {
      enabled: false,
      classes: NOTOPEN_DATE_CLASS,
      tooltip: ''
    }
  }

  datePickerbeforeShowDayEnd (date) {
    let start = moment(this.$start.datepicker('getDate'))
    let date_str = start.format('DD/MM/YYYY')

    if (start.isValid() === false) {
      return {
        enabled: false,
        classes: 'end ' + NOTOPEN_DATE_CLASS,
        tooltip: ''
      }
    }
    let active = this.$end.datepicker('getDate')

    let return_date = this.opendates[date_str][0].return_date

    let flex_returns = []
    if(this.dateHasSlotOpenInFlexForType(date_str)) {
      flex_returns = this.opendates[date_str][0].flex_return_dates
    }

    let end = moment(return_date, 'DD/MM/YYYY')
    let test = moment(date)

    if (test.isSame(end, 'day')) {
      return {
        enabled: true,
        classes: 'end ' + VALID_DATE_CLASS,
        tooltip: ''
      }
    } else if (test.isSame(start, 'day')) {
      return {
        enabled: false,
        classes: 'end ' + SELECT_START_DATE_CLASS,
        tooltip: ''
      }
    } else if (test.isBetween(start, end, 'day')) {
      return {
        enabled: false,
        classes: 'end ' + SELECT_BETWEEN_START_END_DATE_CLASS,
        tooltip: ''
      }
    }
    for (let i = 0; i < flex_returns.length; i++) {
      let f = moment(flex_returns[i], 'DD/MM/YYYY')
      if (test.isSame(f, 'day')) {
        return {
          enabled: true,
          classes: 'end flex ' + VALID_DATE_CLASS,
          tooltip: ''
        }
      }
    }
    return {
      enabled: false,
      classes: 'end ' + NOTOPEN_DATE_CLASS,
      tooltip: ''
    }
  }

  /*
   * Handler Event DatePicker
   * -------------------------------------------------------------------------------------------------------------------
   */

  onShowStart() {
      let thead = $('.datepicker')
      if(thead.find('.no-date-contact').length ==0) {
        thead.prepend('<a class="no-date-contact" href="#" onclick="javascript:window.location.href=\''+$('.btn-dream').attr('href')+';return false;\'">' + this._translation['unavailable-dates'] + '</a>')
      }
      let tfoot = $('.datepicker .table-condensed tfoot')
      tfoot.find('.legend').remove()
      tfoot.append('<tr><td colspan="7" class="legend"><i class="fa fa-circle"></i> ' + this._translation['possible-departures'] + '</td></tr>')
      this.$start.datepicker('place')
  }

  onShowEnd() {
      let thead = $('.datepicker')
      thead.find('.no-date-contact').remove()
      thead.prepend('<a class="no-date-contact" href="#" onclick="javascript:window.location.href=\''+$('.btn-dream').attr('href')+';return false;\'">' + this._translation['unavailable-dates'] + '</a>')
      let tfoot = $('.datepicker .table-condensed tfoot')
      tfoot.find('.legend').remove()
      tfoot.append('<tr><td colspan="7" class="legend"><i class="fa fa-circle"></i> ' + this._translation['possible-returns'] + '</td></tr>')
      this.$end.datepicker('place')
  }

  onClearDate () {
    this.$end.datepicker('clearDates')
    this.$schedule_select.html('')
    this.refreshPriceTable()
  }

  onReturnDateOut() {
    let selected = $('.end.between-start-end-date:not(.disabled), .end.select-end-date')
    selected.removeClass(SELECT_BETWEEN_START_END_DATE_CLASS + ' ' + SELECT_END_DATE_CLASS)
    selected.addClass(VALID_DATE_CLASS)
  }

  onReturnDateHover(cell) {
    let orig_d = cell;
    let curr_d = orig_d;
    curr_d.removeClass(VALID_DATE_CLASS + ' ' + SELECT_BETWEEN_START_END_DATE_CLASS)
    curr_d.addClass(SELECT_END_DATE_CLASS)

    /* Reset prev dates */
    let new_d = curr_d.prev()
    while (1) {
      if(new_d.length == 0) {
        new_d = curr_d.parent().prev().children().last()
      }
      curr_d = new_d
      if(curr_d.hasClass(VALID_DATE_CLASS) || curr_d.hasClass(SELECT_END_DATE_CLASS) ) {
        curr_d.removeClass(VALID_DATE_CLASS + ' ' + SELECT_END_DATE_CLASS + ' ' + ACTIVE)
        curr_d.addClass(SELECT_BETWEEN_START_END_DATE_CLASS)
      } else {
        break
      }
      new_d = curr_d.prev()
    }

    /* Reset next dates */
    curr_d = orig_d;
    new_d = orig_d.next()
    while (1) {
      if(new_d.length == 0) {
        new_d = curr_d.parent().next().children().first()
      }
      curr_d = new_d
      if(curr_d.hasClass(SELECT_BETWEEN_START_END_DATE_CLASS) || curr_d.hasClass(SELECT_END_DATE_CLASS) ) {
        curr_d.removeClass(SELECT_BETWEEN_START_END_DATE_CLASS + ' ' + SELECT_END_DATE_CLASS + ' ' + ACTIVE)
        curr_d.addClass(VALID_DATE_CLASS)
      } else {
        break
      }
      new_d = curr_d.next()
    }
  }

  onChangeStartDate (e) {
    let date = moment(e.date).format('DD/MM/YYYY')
    if(this.opendates[date] === undefined) {
      return
    }
    let inputs = $(':input[name="action-book"], :input[name="action-ask"]')
    if(this.dateIsValid(date) === false){
      inputs.prop('disabled', true)
    } else {
      inputs.prop('disabled', false)
    }

    this.$start.parent().removeClass('invalid')
    this.$end.parent().removeClass('invalid')
    this.$date_wng.hide()

    this.$end.datepicker('clearDates')

    this.refreshSchedule(date)

    if (date) {
      let return_date = this.opendates[date][0].return_date
      this.$end.datepicker('setStartDate', return_date)
      this.$end.datepicker('show')
    }
  }

  onChangeEndDate (e) {
    this.$end.parent().removeClass('invalid')
    this.refreshPriceTable()
  }

  /*
   * Utils Functions
   * -------------------------------------------------------------------------------------------------------------------
   */
  toggle_schedule(mode) {
    if(mode=='show') {
      this.$schedule_select.show()
      this.$schedule_select.prev('label').show()
    } else {
      this.$schedule_select.hide()
      this.$schedule_select.prev('label').hide()
    }
  }

  clear_dates(force_refresh) {
    if(force_refresh || this.$start.val() != '' || this.$end.val() != ''){
      this.$start.datepicker('clearDates').datepicker('hide')
      this.$end.datepicker('clearDates').datepicker('hide')
    }
    this.empty_schedule()
    //no refresh needed here => done by onChangeEndDate previously called
    //this.refreshPriceTable()
  }

  empty_schedule() {
    this.$schedule_select.html('')
    this.toggle_schedule('hide')
  }

  refreshSchedule(date) {
    let hour = ''
    for (let slot of this.opendates[date]) {
      let slot_data = this.checkSlotStatus(slot)
      let disabled = (slot_data['classes'] == VALID_DATE_CLASS)?'':'disabled'
      hour += '<option value="' + slot['start'] + '" title="' + slot_data['tooltip'] + '" ' + disabled + '>' + slot['start'] + '</option>'
    }
    if (date) {
      this.$schedule_select.html(hour)
      if(this.opendates[date].length == 1) {
          this.toggle_schedule('hide')
      } else {
          this.toggle_schedule('show')
      }
    }
    this.$schedule_select.parent().removeClass('invalid')
  }

  getFirstOpenDate () {
    /*
      opened_type is PRIVATE or ADULT
      this.active_type is PRIVATE or SHARED
      :'(
    */
    let remaining_places_type = 'shared'
    if(this.active_type == 'private') {
      remaining_places_type = 'private'
    }

    if(this.opendates[this.searchedDate] != undefined) {
      return moment(this.searchedDate, 'DD/MM/YYYY')
    }

    let opened_dates_for_this_type = []
    for(let date in this.opendates) {
      for (let slot of this.opendates[date]) {
        if(slot.on.indexOf(this.active_type) != -1 &&
           slot.remaining_places[remaining_places_type] > 1) {
          opened_dates_for_this_type.push(date)
          break
        }
      }
    }

    let first_date = moment(
        opened_dates_for_this_type.reduce(
          (a, b) => (moment(a, 'DD/MM/YYYY').isBefore(moment(b, 'DD/MM/YYYY'))) ? a : b
    ), 'DD/MM/YYYY')
    return first_date
  }

  getForm() {
    let form = undefined
    if(this.active_mode == 'gift') {
      form = this.$gift_form
    } else {
      form = this.$booking_form
    }
    return form
  }

  refreshPriceHeading() {
    if(this.active_type == 'private') {
      this.$price_heading.find('.per-pers').hide()
      this.$price_heading.find('.per-group').show()
      this.$price_heading.find('.price').text(this.$price_heading.data('min-price-private'))
    } else {
      this.$price_heading.find('.per-group').hide()
      this.$price_heading.find('.per-pers').show()
      this.$price_heading.find('.price').text(this.$price_heading.data('min-price-adult'))
    }
  }

  refreshPriceTable() {
    let start = moment(this.$start.datepicker('getDate'))
    let end = moment(this.$end.datepicker('getDate'))

    if((start._isValid && end._isValid) || this.active_mode == 'gift') {

      var query_string = this.getForm().serialize()

      this.GetActivityPriceService.get(this.id, query_string).then((data) => {
        this.$price_detail_targets.price_per.text(data.by)
        this.$price_detail_targets.unit_price.text(data.unit_price_txt)
        this.$price_detail_targets.duration.text(data.duration)
        this.$price_detail_targets.travelers_nb.text(data.travelers_nb)
        this.$price_detail_targets.total_price.text(data.price_txt)
        this.$price_detail_targets.promo.html(data.promo_txt)
        if (data.promo_txt == '') {
          this.$price_detail_targets.promo.parents('tr').hide()
        } else {
          this.$price_detail_targets.promo.parents('tr').show()
        }
        this.$price_detail_targets.warning_msg.text(data.warning_msg)
        if (data.warning_msg == '') {
          this.$price_detail_targets.warning_msg.parents('tr').hide()
        } else {
          this.$price_detail_targets.warning_msg.parents('tr').show()
        }
        this.$price_detail_table.show();
        this.$price_detail_table.find('tr:visible:odd').css('background', '#F5F5F5');
        this.$price_detail_table.find('tr:visible:even').css('background', '#FFFFFF');
      })

    } else {

        this.$price_detail_table.hide();

    }

  }
}



// WEBPACK FOOTER //
// ./activity/static/activity/js/components/reservation-panel.js